import { categoriasContenido } from '@/content/site'
import { Icon } from '@/components/Icon'
import styles from './Contenido.module.css'

const videoTipos = [
  'Videos breves hablando a cámara',
  'Fragmentos de charlas',
  'Entrevistas y podcast',
  'Talleres y apariciones en medios',
]

export function Contenido() {
  return (
    <section id="contenido" className="section section--tint">
      <div className="container">
        <header className={`${styles.head} reveal`}>
          <p className="eyebrow">Contenido · Ideas para crecer</p>
          <h2 className="section-title">Un centro de contenido para pensar y avanzar</h2>
          <p className="section-lead">
            Artículos y recursos organizados por categorías. Un mismo tema puede convertirse en
            artículo, publicación, newsletter y, más adelante, en una charla.
          </p>
        </header>

        <div className={styles.categories}>
          {categoriasContenido.map((c) => (
            <span key={c} className={`${styles.chip} reveal`}>
              {c}
            </span>
          ))}
        </div>

        <div className={styles.panels}>
          <article className={`${styles.featured} reveal`}>
            <span className={styles.tag}>Ejemplo de tema</span>
            <h3 className={styles.featuredTitle}>
              ¿Por qué abandonamos nuestras metas aunque realmente queramos conseguirlas?
            </h3>
            <p className={styles.featuredText}>
              Contenido que combina psicología, trabajo y desarrollo personal para transformar
              intenciones en acciones sostenibles.
            </p>
            <a href="#contenido" className="arrow-link">
              Leer contenido
              <Icon name="arrow" size={18} />
            </a>
          </article>

          <article className={`${styles.video} reveal`}>
            <div className={styles.videoHead}>
              <span className={styles.playBtn}>
                <Icon name="play" size={22} />
              </span>
              <div>
                <h3 className={styles.videoTitle}>Emilia en acción</h3>
                <p className={styles.videoSub}>Conoce su forma de comunicar antes de contratar.</p>
              </div>
            </div>
            <ul className={styles.videoList}>
              {videoTipos.map((v) => (
                <li key={v}>{v}</li>
              ))}
            </ul>
          </article>
        </div>
      </div>
    </section>
  )
}
